<template>
  <div class="form-panel flex" ref="multipleTable">

    <div class="form-panel-column-50" style="height:45px;width:50%">
      <span class="txt">物料描述：</span>
      <el-input  placeholder="暂无物料描述" v-model="batchFeature.materialDesc"  :disabled="freezeComponent"></el-input>
    </div>
    <div class="form-panel-column-50" style="height:45px">      
      <span class="txt" >规格：</span>
      <el-input  placeholder="暂无规格" v-model="batchFeature.specifications"></el-input>
	    <span style="width:30px;line-height:40px;margin-left:10px;font-size:14px">ML</span>
    </div>
    <div class="active_rumb" style="height:1%"></div>
    
    <!-- v-bind:true-value="1" v-bind:false-value="0" -->
    <div class="form-panel-column-30">
        <el-checkbox style="margin-top:7px" v-model="groupBuyingIndicator">团购指示符</el-checkbox>
    </div>
    <div class="form-panel-column-35">
			<span class="txt">团购基准：</span>
			<el-select v-model="batchFeature.groupBuyingStandard" :disabled="!groupBuyingIndicator" placeholder="请选择团购基准">
        <el-option
          v-for="(item,index) in groupBuyingRecords"
          :label="item.specifications"
          :value="item.specifications"
          :key="index">
          <span style="float: left">{{ item.specifications}}ML</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.price}}元</span>
        </el-option>        
      </el-select>
      <span style="width:40px;line-height:40px;margin-left:10px;font-size:14px">ML</span>
		</div>
    <div class="form-panel-column-35">
      <span class="txt" >{{groupBuyingPriceDesc}}</span>
    </div>
    <div class="active_rumb" style="height:1%"></div>

    <!-- v-bind:true-value="1" v-bind:false-value="0" -->
    <div class="form-panel-column-30">
        <el-checkbox style="margin-top:7px" v-model="wholesalesIndicator">批发指示符</el-checkbox>
    </div>
    <div class="form-panel-column-35">
			<span class="txt">批发基准：</span>
			<el-select v-model="batchFeature.wholesalesStandard" :disabled="!wholesalesIndicator" placeholder="请选择批发基准">
        <el-option
          v-for="(item,index) in wholesalesRecords"
          :label="item.specifications"
          :value="item.specifications"
          :key="index"
          >
          <span style="float: left">{{ item.specifications}}ML</span>
          <span style="float: right; color: #8492a6; font-size: 13px">{{ item.price}}元</span>
        </el-option>        
      </el-select>
      <span style="width:40px;line-height:40px;margin-left:10px;font-size:14px">ML</span>
		</div>
    <div class="form-panel-column-35">
      <span class="txt" >{{wholesalesPriceDesc}}</span>
      <!-- <el-input  placeholder="暂无规格" v-model="batchFeature.specifications"></el-input> -->
    </div>

  
    <!-- v-bind:true-value="1" v-bind:false-value="0" -->
    <div class="form-panel-column-30">
        <el-checkbox style="margin-top:7px" v-model="retailIndicator">零售指示符</el-checkbox>
    </div>
    <div class="form-panel-column-35">
			<span class="txt">零售基准：</span>
			<el-select v-model="batchFeature.retailStandard" :disabled="!retailIndicator" placeholder="请选择零售基准">
        <el-option
          v-for="(item,index) in retailRecords"
          :label="item.specifications"
          :value="item.specifications"
          :key="index"
          >
          <span style="float: left">{{ item.specifications}}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">ML</span>
        </el-option>        
      </el-select>
      <span style="width:40px;line-height:40px;margin-left:10px;font-size:14px">ML</span>
		</div>
    <div class="form-panel-column-35">
      <span class="txt" >{{retailPriceDesc}}</span>
      <!-- <el-input  placeholder="暂无规格" v-model="batchFeature.specifications"></el-input> -->
    </div>
    <div class="active_rumb" style="height:1%"></div>

    <div class="form-panel-column-50" style="height:45px;width:49%">
      <span class="txt">有效日期：从</span>
      <el-date-picker type="date" placeholder="选择日期" v-model="batchFeature.validStartDate"></el-date-picker>
    </div>
    <div class="form-panel-column-50" style="height:45px;width:51%">
      <span class="txt">到</span>
      <el-date-picker type="date" placeholder="选择日期" v-model="batchFeature.validEndDate"></el-date-picker>
    </div>
    <div class="active_rumb" style="height:1%"></div>
    <div class="form-panel-row-column" style="width:400px">
     <el-checkbox style="margin-top:8px" v-model="batchFeature.deleteMark">删除标识</el-checkbox>
    </div>
    
  </div>
</template>

<script>
import { fstockApi, customerApi, matterApi } from "api/base.js";
import { targetUnit } from "api/business.js";
import { mapState, mapActions } from "vuex";

export default {
  components: {},
  props: {
    batchFeature: Object,
    groupBuyingRecords:Array,
    wholesalesRecords:Array,
    retailRecords:Array,
    specificationRecords:Array
  },
  data() {
    return {
      deleteMark: false,
      freezeComponent:true,
      groupBuyingIndicator:false,
      wholesalesIndicator:false,
      retailIndicator:false
    };
  },
  created() {
       if(this.batchFeature){
          this.inputIndicatorCvt(this.batchFeature);
       }       
       if(!this.batchFeature.validStartDate){
          this.batchFeature.validStartDate=new Date();
       }
       if(!this.batchFeature.validEndDate){
          this.batchFeature.validEndDate=new Date("2999-01-01");
       }       
  },
  computed: {
        /**
         * 团购价
         */
        groupBuyingPriceDesc:function(){
          if(!this.batchFeature.groupBuyingStandard){
            return ""
          }
          if(!this.groupBuyingRecords){
            return ""
          }
          let existsBatchFeature=this.groupBuyingRecords.find(item=>item.specifications==this.batchFeature.groupBuyingStandard);
          if(!existsBatchFeature){
            return ""
          }
          let batchFeaturePrice=existsBatchFeature.price;
          if(!batchFeaturePrice){
            return "";
          }
          //计算原折扣单价
          let oriDiscountUnitPrice=existsBatchFeature.price/existsBatchFeature.specifications;
          //当前折扣单价=原折扣单价*当前折扣率
          let currentDiscountUnitPrice=oriDiscountUnitPrice*existsBatchFeature.discountRate/100;
          
          //批发价=原折扣单价*本次优惠百分比*本次规格
          this.batchFeature.specifications=this.batchFeature.specifications||0;
          let groupBuyingPrice=currentDiscountUnitPrice*this.batchFeature.specifications;
          this.batchFeature.groupBuyingPrice=this.toDecimal(groupBuyingPrice);
          if(this.batchFeature.groupBuyingPrice){
            return "团购价:"+this.batchFeature.groupBuyingPrice+"元";
          }else{
            return ""
          }
        },
        /**
         * 批发价
         */
        wholesalesPriceDesc:function(){  
          debugger;        
          if(!this.batchFeature.wholesalesStandard){
            return ""
          }
          if(!this.wholesalesRecords){
            return ""
          }
          let existsBatchFeature=this.wholesalesRecords.find(item=>item.specifications==this.batchFeature.wholesalesStandard);
          if(!existsBatchFeature){
            return ""
          }
          let batchFeaturePrice=existsBatchFeature.price;
          if(!batchFeaturePrice){
            return "";
          }
          if(!existsBatchFeature.discountRate){
            existsBatchFeature.discountRate=100;
          }
          //计算原折扣单价
          let oriDiscountUnitPrice=existsBatchFeature.price/existsBatchFeature.specifications;
          //当前折扣单价=原折扣单价*当前折扣率
          let currentDiscountUnitPrice=oriDiscountUnitPrice*existsBatchFeature.discountRate/100;
          
          //批发价=原折扣单价*本次优惠百分比*本次规格
          this.batchFeature.specifications=this.batchFeature.specifications||0;
          let wholesalesPrice=currentDiscountUnitPrice*this.batchFeature.specifications;
          this.batchFeature.wholesalesPrice=this.toDecimal(wholesalesPrice);
          if(this.batchFeature.wholesalesPrice){
            return "批发价:"+this.batchFeature.wholesalesPrice+"元";
          }else{
            return ""
          }
        },
        /**
         * 零售价
         */
        retailPriceDesc:function(){          
          if(!this.batchFeature.retailStandard){
            return ""
          }
          if(!this.retailRecords){
            return ""
          }
          let existsBatchFeature=this.retailRecords.find(item=>item.specifications==this.batchFeature.retailStandard);
          if(!existsBatchFeature){
            return ""
          }
          let batchFeaturePrice=existsBatchFeature.price;
          if(!batchFeaturePrice){
            return "";
          }
          if(existsBatchFeature.discountRate){
            existsBatchFeature.discountRate=100;
          }
          //计算原折扣单价
          let oriDiscountUnitPrice=existsBatchFeature.price/existsBatchFeature.specifications;
          //当前折扣单价=原折扣单价*当前折扣率
          let currentDiscountUnitPrice=oriDiscountUnitPrice*existsBatchFeature.discountRate/100;
          
          //批发价=原折扣单价*本次优惠百分比*本次规格
          this.batchFeature.specifications=this.batchFeature.specifications||0;
          this.batchFeature.retailPrice=currentDiscountUnitPrice*this.batchFeature.specifications;
          let retailPrice=this.toDecimal(retailPrice);
          if(this.batchFeature.retailPrice){
            return "零售价:"+this.batchFeature.retailPrice+"元";
          }else{
            return ""
          }
        }
        
  },
  methods: {
    //取消选择
    cancelSelect() {  

    },
    toDecimal(decimal) {   
        var decimal= parseFloat(decimal);
        if (isNaN(decimal)) {   
          return;    
        } 
        return Math.round(decimal);                 
        //return Math.round(decimal*100)/100               
    },
    /**
     * 清空选中的标识
     */
    clearCheckedIndicator(){
      this.groupBuyingIndicator=false;
      this.wholesalesIndicator=false;
      this.retailIndicator=false;
    },
    /**
     * 标识符类型值转换
     */
    outpuIndicatorCvt(){
      this.batchFeature.groupBuyingIndicator=this.groupBuyingIndicator==true?1:0;
      this.batchFeature.wholesalesIndicator=this.wholesalesIndicator==true?1:0;
      this.batchFeature.retailIndicator=this.retailIndicator==true?1:0;
    },
    /**
     * 输入标识标识转换
     */
    inputIndicatorCvt(row){      
      this.groupBuyingIndicator=row.groupBuyingIndicator==1?true:false;
      this.wholesalesIndicator=row.wholesalesIndicator==1?true:false;
      this.retailIndicator=row.retailIndicator==1?true:false;
    }
  }
};
</script>

<style>
</style>
